import React, { ElementRef, useEffect, useRef } from "react";

import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { useInView } from "react-intersection-observer";

interface SuggestionItemProps {
  suggestion: string;
  input: string;
  isDisabled?: boolean;
  isHighlighted: boolean;
  onClick: (value: string, e: any) => void;
}

const SuggestionItem: React.FC<SuggestionItemProps> = (props) => {
  const { suggestion, onClick, input, isHighlighted, isDisabled } = props;

  const itemElementRefrence = useRef<HTMLDivElement | null>(null);
  const [bottomReference, bottomInView] = useInView();
  const [topReference, topInView] = useInView();

  const matches = match(suggestion, input);
  const suggestionParts = parse(suggestion, matches);

  useEffect(() => {
    if (isHighlighted && !bottomInView) {
      itemElementRefrence?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    } else if (isHighlighted && !topInView) {
      itemElementRefrence?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [isHighlighted]);

  return (
    <div ref={itemElementRefrence}>
      <div ref={topReference} />
      <div>
        <li
          className={`p-2 cursor-pointer hover:bg-mofidGray-10 flex justify-between items-center ${
            isHighlighted ? "bg-mofidGray-30" : "bg-white"
          }`}
          onClick={(e) => onClick(suggestion, e)}
        >
          <div>
            {suggestionParts.map((part, index) =>
              part.highlight ? (
                <span key={String(index)} className="text-primary-60 font-bold">
                  {part.text}
                </span>
              ) : (
                <span key={String(index)}>{part.text}</span>
              )
            )}
          </div>
          {isDisabled && <span className="text-red-70">غیر فعال</span>}
        </li>
      </div>

      <div ref={bottomReference} />
    </div>
  );
};

export default SuggestionItem;
